/**
 * Maps dedicated client subdomains ({client}.mentoralift.ai) to Auth0 organization IDs.
 * Add new clients here; override or extend via VITE_CLIENT_HOST_ORG_MAP in env.
 */
export const DEFAULT_CLIENT_HOST_ORG_MAP: Record<string, string> = {
  heb: 'org_1e8xFGkdioqQT2w4',
};

/** Subdomains that are not tenant-specific client hosts. */
export const RESERVED_CLIENT_HOSTS = new Set([
  'www',
  'app',
  'api',
  'stage',
  'dev',
  'admin',
  'cdn',
  'static',
]);

export const DEFAULT_APP_BASE_DOMAIN = 'mentoralift.ai';

function parseClientHostOrgMapFromEnv(): Record<string, string> {
  const raw = import.meta.env.VITE_CLIENT_HOST_ORG_MAP?.trim();
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return Object.fromEntries(
      Object.entries(parsed).flatMap(([hostKey, orgId]) => {
        if (typeof orgId !== 'string' || !orgId.trim()) return [];
        return [[hostKey.trim().toLowerCase(), orgId.trim()]];
      })
    );
  } catch {
    console.warn('Invalid VITE_CLIENT_HOST_ORG_MAP — expected JSON object.');
    return {};
  }
}

export function getClientHostOrgMap(): Record<string, string> {
  return {
    ...DEFAULT_CLIENT_HOST_ORG_MAP,
    ...parseClientHostOrgMapFromEnv(),
  };
}
